import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/angielski';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-257" data-mp="30xq4jav4cet7">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-258" data-mp="2w56q6bolxfnc">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-259" data-mp="2r7wre5fbvrmu">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-260" data-mp="2m8bus1nmrvda">
            Czy znasz to z własnego doświadczenia?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-261" data-mp="2i55gc6qd6xvq">
            Jeśli odpowiesz „tak” choć na jedno pytanie, ANGIELSKI GOTOWY™ jest dla Ciebie.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-262" data-mp="289ubqh8o771p">
            Zasługujesz na prostsze rozwiązanie
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-263" data-mp="6f33agmayjwm" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-264" data-mp="3nngpbpk1i5j0">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-265" data-mp="3elh6crpgsrdf">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-266" data-mp="3entwvt9aga23">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-267" data-mp="b5jwykz4nng5" />
                </span>
                <div data-id="element-268" data-mp="3sma3zlb2c2kr">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-269" data-mp="3skqq21cvq3m5">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-270" data-mp="1efhlk5ji0ks">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}